export default __webpack_public_path__ + "static/rings-1338671067b962b605b889bda4df260e.png";